import {
  ErrorTranslationKeys,
  createErrorTranslationKey,
} from 'constants/error-translation-keys';
import { ErrorKey } from 'hooks/checkout/useExpressCheckoutError/type';
import { HttpStatus } from '../../constants/http-status';

export default {
  'error:invalid_login': 'Password or email are incorrect.',
  'error:email_in_use':
    'An account already exists for this email. Use the login to log in to your Pets Deli account.',
  'error:account_suspended':
    'To access your customer account, please contact our customer service: office@petsdeli.de',

  // Password reset
  'error:Could not find customer': 'Customer could not be found',
  'error:Ungültige URL zum Zurücksetzen':
    'The link has expired. Request a new one!',

  'error:graphql:Too many requests. Please try again in a few seconds':
    'Too many requests. Please try again in a few seconds.',

  'error:unknown': 'Oops – something went wrong. Please try again later.',
  'error:unknown_error': 'Oops – something went wrong. Please try again later.',
  [`error:http-status:${HttpStatus.BAD_REQUEST}`]:
    'The request message was malformed',
  [`error:http-status:${HttpStatus.UNAUTHORIZED}`]:
    'The request cannot be made without valid authentication',
  [`error:http-status:${HttpStatus.FORBIDDEN}`]:
    'The request was not carried out due to lack of client authorization',
  [`error:http-status:${HttpStatus.NOT_FOUND}`]:
    'The requested resource was not found',
  [`error:http-status:${HttpStatus.INTERNAL_SERVER_ERROR}`]:
    'A server error occurred',
  [`error:http-status:${HttpStatus.BAD_GATEWAY}`]:
    'The server could not fulfill its function as a gateway or proxy',
  [`error:http-status:${HttpStatus.SERVICE_UNAVAILABLE}`]:
    'The server is temporarily unavailable',

  [`error:express-checkout:${ErrorKey.Undefined}`]:
    'The payment could not be completed. Please use another method.',
  [`error:express-checkout:${ErrorKey.Unknown}`]:
    'The payment could not be completed. Please use another method.',
  'error:account:bonus-program:insufficient': 'Insufficient points',
  'error:express-checkout:invalid-address':
    'An order via petsdeli.de is not possible at this address.',
  [`error:express-checkout:${ErrorKey.InstrumentDeclined}`]:
    'Unfortunately, your payment failed. Please check the card limit or available amount on the card.',
  'error:page:page-title:page-not-found': 'Page not found',
  'error:page:page-title:error': 'Error',
  'error:page:header': "We can't find the page you're looking for.",
  'error:page:suggestions:header': 'Here are some helpful links instead:',
  'error:page:suggestions:home': 'Home',
  'error:page:suggestions:foodaid': 'Food Advisor',
  'error:page:suggestions:foodaid:handle':
    'our-food-consultation-online-and-by-phone',
  'error:page:suggestions:account': 'Account',
  'error:page:suggestions:cart': 'Cart',
  'error:page:generic-error-message': 'Oops – something went wrong!',
  'error:invoice-download-error-message': "Your invoice isn't available yet.",

  'error:products:product-not-available':
    'Unfortunately, the selected product is no longer available.',
  'error:products:unrecoverable-shopify-checkout-error':
    "Oops – something went wrong with your cart. We've reset it for you.",
  [createErrorTranslationKey(
    ErrorTranslationKeys.UNIQUE_CONSTRAINT.PREFIX,
    ErrorTranslationKeys.UNIQUE_CONSTRAINT.TYPES.PET_NAME_EXISTS
  )]: 'You already have an existing profile with this name.',
};
